import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import { ListItemGraphic} from 'rmwc/List';
import UserUploadedResComponent from '../learning_resource_user/UserUploadedResComponent';
import ReactGA from 'react-ga';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {stateToHTML} from 'draft-js-export-html';

class UserResourceUpload extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            loadingState: true,
            snackbarIsOpen: false,
            addFormOpen: false,
            uploadFormOpen: false,
            uploadDisableButton: true,
            saveButtonDisable: false,
            addedTaxonomyParent: [],
            addedStandard: [],
    		data:{
                resourceName: '',
                resourceLink: '',
                resourceAuthor: '',
                resourceDescription: EditorState.createEmpty(),
                taxonomyComboDropDown: [],
                standardComboDropDown: [],
                resourceDetails: []
    		},
            fileError: '',
            errorMsg: ''
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()
        this.props.history.push('/portal/app/learning_resources/my_learning_plan')
    }

    handleTaxonomyParentChange = (option) => {
        this.setState(state => {
            return {
                addedStandard : [],
                addedTaxonomyParent : option
            };
        });
        this.handleFetchAssociatedStandards(option)
    }

    handleFetchAssociatedStandards = (option) => {
        let selectedAspect = []
        let data = Object.assign({}, this.state.data)

        var myAspectArray = option;
        var aspectLength = myAspectArray.length;
        for (var i = 0; i < aspectLength; i++) {
            selectedAspect.push(parseInt(myAspectArray[i].value))
        }

        let value = {
            'selected_aspect' : selectedAspect
        }

        api.userAspectAssociatedStandards(this.props.user.accessToken, value)
        .then((result) => {
            if (result.status === 'success') {
                data.standardComboDropDown = result.data
                this.setState({data:data})
            }
        })
    }

    handleStandardChange = (option) => {
        this.setState(state => {
            return {
                addedStandard : option
            };
        });
    }

    handleUploadForm = () => {
        this.setState({uploadFormOpen: true, addFormOpen: false})
    }

    handleAddForm = () => {
        this.setState({addFormOpen: true, uploadFormOpen: false})
    }

    handleResourceNameChange = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        data.resourceName = e.target.value
        this.setState({data: data}) 
    }

    handleResourceLinkChange = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        data.resourceLink = e.target.value
        this.setState({data: data}) 
    }

    handleResourceAuthorChange = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)
        data.resourceAuthor = e.target.value
        this.setState({data: data}) 
    }

    handleResourceDescChange: Function = (editorState) => {
        let data = Object.assign({}, this.state.data)
        data.resourceDescription = editorState
        this.setState({data: data});
    }

    handleCancelUpload = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)

        data.resourceName = ''
        data.resourceLink = ''
        data.resourceAuthor = ''
        data.resourceDescription = ''
        this.setState({uploadFormOpen: false, addFormOpen: false, data: data, addedTaxonomyParent: [], addedStandard: [], errorMsg: '', fileError: '', saveButtonDisable: false})
    }

     validateUpload = (event) =>{
        if (event.target.files[0] === undefined){
            return this.setState({uploadDisableButton: true})
        }
        let file_name = event.target.files[0].name;
        let fileSize = event.target.files[0].size/1024/1024;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

        if ((extension === "pdf") || (extension === "doc") || (extension === "docx")){
            if (fileSize > 10) {
                return this.setState({uploadDisableButton: true, fileError: 'File size exceeds the permisible limit. Please make sure that the file is less than 10 MB.'})
            }
            this.setState({uploadDisableButton: false, fileError: ''})
        }
        else{
            this.setState({uploadDisableButton: true, fileError: 'Invalid File Format. Upload PDF, DOCX or DOC file only.'})
        }
    }

    userResourcesFetch = (e) => {
        let data = Object.assign({}, this.state.data)

        console.log('Calling the refresh option!')

        api.getUserUploadedResource(this.props.user.accessToken)
        .then((result) => {
            if (result.status === 'success'){
                data.resourceDetails = result.data
                this.setState({data: data, loadingState: false})
            }
        })
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)

        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview('/user_resource_upload');

        return api.getUserAspects(this.props.user.accessToken)
        .then((result) => {
            if (result.status === 'success') {
                data.taxonomyComboDropDown = result.data
                this.setState({data: data})
                this.userResourcesFetch()
            }
        })
    }

    handleResourceSave = (e) => {
        e.preventDefault()
        this.setState({saveButtonDisable: true})

        let htmlText = stateToHTML(this.state.data.resourceDescription.getCurrentContent())

        if (htmlText.length > 3000){
            return this.setState({errorMsg: `Description is too long. Please change the description accordingly.`, saveButtonDisable: false})
        }

        if (this.state.addFormOpen === true) {
            if (this.state.data.resourceLink === '') {
                return this.setState({errorMsg: 'Please enter the link of the resource before adding a resource. All fields are mandatory.', saveButtonDisable: false})
            }
        }

        if ((this.state.data.resourceName === '') || (this.state.addedTaxonomyParent.length === 0) || (this.state.addedStandard.length === 0)){
            return this.setState({errorMsg: 'Please enter the necessary details before adding the resource. All fields are mandatory.', saveButtonDisable: false})
        }

        let data = Object.assign({}, this.state.data)
        const formData = new FormData(e.target);

        var taxonomyArray = this.state.addedTaxonomyParent;
        var taxonomyLength = taxonomyArray.length;
        let selectedTaxonomyString = []
        for (var z = 0; z < taxonomyLength; z++) {
            selectedTaxonomyString.push(parseInt(taxonomyArray[z].value))
        }

        var standardArray = this.state.addedStandard;
        var standardLength = standardArray.length;
        let selectedStandardString = []
        for (var z = 0; z < standardLength; z++) {
            selectedStandardString.push(parseInt(standardArray[z].value))
        }

        formData.append("resourcedesc", htmlText)
        formData.append("standards", selectedStandardString)
        formData.append("aspects", selectedTaxonomyString)

        api.userUploadResource(this.props.user.accessToken, formData)
        .then((result) => {
            if (result.status === 'success') {
                this.setState({saveButtonDisable: false})
                this.handleCancelUpload(e)
                this.userResourcesFetch()
                this.setState({snackbarIsOpen: !this.state.snackbarIsOpen})
            }
            else {
                this.setState({saveButtonDisable: false})
            }
        })
    }

    render(){
        const { resourceDescription } = this.state.data;
        let handleUploadForm = this.handleUploadForm
        let handleAddForm = this.handleAddForm
        let handleBackAction = this.handleBackAction
        let handleCancelUpload = this.handleCancelUpload
        let handleResourceSave = this.handleResourceSave
        let userResourcesFetch = this.userResourcesFetch
        let mainPageContent, addUploadForm, individualResource
        let docField, linkField, hiddenComponent, uploadButtonComponent
        let userType = 'User'

        let Snackbarcomponent =(
            <Snackbar
                show={this.state.snackbarIsOpen}
                onHide={evt => this.setState({snackbarIsOpen: false})}
                message="Resource successfully added/uploaded"
            />
        )

        if (this.state.data.resourceDetails.length > 0){
            individualResource = (
                <Grid className="opportunity-list-item">
                    {this.state.data.resourceDetails.map(function(resource){
                        let uniq = Math.random() * resource.id 
                        return (
                            <GridCell span = "12" key = {uniq}>
                                <Card style={{padding: '0px'}}>
                                    <UserUploadedResComponent resourceId = {resource.id}
                                        resourceName = {resource.name}
                                        resourceAuthor = {resource.author}
                                        resourceDescription = {resource.description}
                                        resourceStatus = {resource.status}
                                        resourceLink = {resource.resource_link}
                                        resourceType = {resource.resource_type}
                                        aspects = {resource.aspects}
                                        standards = {resource.standards}
                                        submissionDate = {resource.submitted_at}
                                        onHandleResourceUpdate = {userResourcesFetch}
                                        isAdmin = {false}
                                        userType = {userType}
                                    />
                                </Card>
                            </GridCell>
                        )
                    })}
                </Grid>
            )
        }

        if (this.state.saveButtonDisable === false) {
            if ((this.state.uploadDisableButton === true) && (this.state.uploadFormOpen === true)){
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised disabled style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
            else{
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
        }
        else {
            uploadButtonComponent = (
                <GridCell span = "3">
                    <Button raised disabled style={{ width: '100%'}}>In Process</Button>
                </GridCell>
            )
        }


        if (this.state.addFormOpen === true){
            linkField = (
                <GridCell span="12">
                    <TextField fullwidth className = 'test_input' label="Link of the Resource" autoComplete="off"  name="resourcelink" defaultValue = {this.state.data.resourceLink} onChange = {this.handleResourceLinkChange} style={{ height: '140%' }}/>
                </GridCell>
            )
            hiddenComponent = (
                <div>
                    <TextField autoComplete="off" hidden name="resourcetype"  value="link"/>
                </div>
            )
        }

        if (this.state.uploadFormOpen === true){
            docField = (
                <GridCell span="12">
                    <Typography>Please add the resource document here: </Typography><input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
                </GridCell>
            )
            hiddenComponent = (
                <div>
                    <TextField autoComplete="off" hidden name="resourcetype"  value="document"/>
                </div>
            )
        }

        if ((this.state.addFormOpen === true) || (this.state.uploadFormOpen === true)) {
            addUploadForm = (
                <div>
                    <Card style={{padding: '25px'}}>
                        <div>
                            <form onSubmit= {((e) => this.handleResourceSave(e))} style={{ width: '100%' }}>
                                <Grid className="opportunity-list-item">
                                    <GridCell span="8">
                                        <TextField fullwidth label="Name of the Resource" autoComplete="off"  name="resourcename" defaultValue = {this.state.data.resourceName} onChange = {this.handleResourceNameChange} style={{ height: '140%' }}/>
                                    </GridCell>
                                    <GridCell span="4">
                                        <TextField fullwidth label="Author of the Resource" autoComplete="off"  name="resourceauthor" defaultValue = {this.state.data.resourceAuthor} onChange = {this.handleResourceAuthorChange} style={{ height: '140%' }}/>
                                    </GridCell>
                                    {docField}
                                    {linkField}
                                    <GridCell span="12">
                                        <div className = "description-panel" >
                                            <Editor
                                                editorState={resourceDescription}
                                                wrapperClassName="demo-wrapper"
                                                editorClassName="demo-editor"
                                                onEditorStateChange={this.handleResourceDescChange}
                                                toolbar={{
                                                    options:['inline', 'list' ],
                                                    link: { inDropdown: true },
                                                    inline:
                                                        {
                                                            options:['bold', 'italic', 'underline']
                                                        },
                                                }}
                                            />
                                        </div>
                                    </GridCell>
                                    <GridCell span = "6">
                                        <Reactsel
                                            name="taxonomylist"
                                            onChange={this.handleTaxonomyParentChange}
                                            value={this.state.addedTaxonomyParent}
                                            options={this.state.data.taxonomyComboDropDown}
                                            placeholder="--Select an Aspect--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "6">
                                        <Reactsel
                                            name="standardlist"
                                            onChange={this.handleStandardChange}
                                            value={this.state.addedStandard}
                                            options={this.state.data.standardComboDropDown}
                                            placeholder="--Select a Standard--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "12">
                                        <Grid>
                                            {uploadButtonComponent}
                                            <GridCell span = "3">
                                                <Button dense style={{ width: '100%' }} onClick= {((e) => handleCancelUpload(e))}>Cancel</Button>
                                            </GridCell>
                                            <GridCell span = "6">
                                                {hiddenComponent}
                                            </GridCell>
                                        </Grid>
                                    </GridCell>
                                </Grid>
                            </form>
                        </div>
                        <StatusMessage error_msg = {this.state.errorMsg} />
                        <StatusMessage error_msg = {this.state.fileError} />
                    </Card>
                </div>
            )
        }

        if (this.state.loadingState === true) {
            mainPageContent = (
                <div className="loader-component">
                    <div className="loader"></div>
                </div>
            )
        }
        else {
        	mainPageContent = (
                <div>
            		<Grid>
            			<GridCell span = "12">
                            <Card style={{padding: '0px'}}>
                				<Grid>
                                    <GridCell span = "11">
                                        <Typography use="headline5">Contribute a Resource</Typography>
                                    </GridCell>
                                    <GridCell span = "1">
                                        <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                                    </GridCell>
                                </Grid>
                            </Card>
            			</GridCell>
                        <GridCell span = "12">
                            <Typography use="caption">In this section you can share resources which you would want to be a part of the MyCENTA Learning Resources bank. These resources could be your own or those you might have come across. You can either provide a link to the resource or upload a document. After filling in the relevant details, please click on the Submit button to share the resource with us. Please make sure that you tag the resource to the relevant Aspects and CENTA Standards therein. We will go through the submitted resource and depending on the quality and relevance it would either be approved or turned down. In case the resource gets approved, it will subsequently become a part of the MyCENTA Learning Resources.</Typography>
                        </GridCell>
                        <GridCell span = "2">
                            <Button raised style={{ width: '100%' }} onClick = {((e) => handleUploadForm(e))}>Upload a Doc.</Button>
                        </GridCell>
                        <GridCell span = "2">
                            <Button raised style={{ width: '100%' }} onClick = {((e) => handleAddForm(e))}>Add a Link</Button>
                        </GridCell>
                        <GridCell span = "12">
                            {addUploadForm}
                        </GridCell>
            		</Grid>
                    {individualResource}
                    {Snackbarcomponent}
                </div>
        	)
        }
    	return(
    		<div>
    			{mainPageContent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserResourceUpload);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/UserResourceUpload.jsx